import styled from 'styled-components'

import { ClinTheme } from '../../../ClinTheme'
import { StyledAccordion } from '../../../components/ClinAccordion/ClinAccordion.styles'
import { StyledClinText } from '../../../components/ClinText/ClinText.styles'
import {
  betweenQueryTooltip,
  mediaQuery,
  mediaQueryDown
} from '../../../utils/mediaQuery'
import { ClinText } from '../../../components/ClinText'
import { IClinTextProps } from '../../../components/ClinText/ClinText'
import {
  ClinPatientTableHeaderCell,
  ClinTableBodyCell,
  ClinTableRow
} from '../../../components/ClinTable/ClinTable'
import { ClinTable } from '../../../components/ClinTable'
import { Col, Row } from 'react-grid-system'

const MediumUpBreakpoint = ClinTheme.breakpoints[2]
const mobileUpBreakpoint = ClinTheme.breakpoints[0]
interface IColumnProps {
  noBorder?: boolean
}
interface ClinTableRowStyledProps {
  background?: string
  isOpen?: boolean
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}
interface IHeaderColumnProps {
  hasBookmark?: boolean
}

export const StyledDocumentationIcon = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0 0 138px',
  height: 138,
  background: ClinTheme.colors.lightGrey
})

export const StyledSKUQuantitySelector = styled.div({
  padding: ClinTheme.space[4],
  [`.price-row`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  [`.price-title`]: {
    flex: '1 0 50%'
  }
})

export const StyledProductAccordion = styled.div({
  '.clin-icon-title, .clin-icon-value': {
    flex: '0 0 50%'
  }
})

export const StyledHoldItem = styled.div({
  borderTop: '1px solid ' + ClinTheme.colors.grey,
  [`:last-child`]: {
    borderBottom: '1px solid ' + ClinTheme.colors.grey
  },
  [`.sku-information, .warehouse-address`]: {
    flexBasis: '100%'
  }
})

export const StyledHeaderColumn = styled('div')(
  {
    maxWidth: '75%',
    [mediaQueryDown(mobileUpBreakpoint)]: {
      width: '100%',
      maxWidth: '100%'
    }
  },
  ({ hasBookmark }: IHeaderColumnProps) =>
    hasBookmark ? { marginLeft: 'auto' } : {}
)

export const StyledEstimatedDeliveryDate = styled('div')({
  width: '100%',
  maxWidth: '100%',
  padding: `0 ${ClinTheme.space[2]}px`
})

export const StyleDocumentationDetails = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  marginLeft: ClinTheme.space[3],
  width: '100%',

  [mediaQuery(MediumUpBreakpoint)]: {
    flexDirection: 'row'
  }
})

export const StyledDocumentCard = styled.div({
  display: 'flex',
  flex: '0 0 auto',
  flexDirection: 'column',
  marginBottom: ClinTheme.space[5],
  paddingBottom: ClinTheme.space[5],
  borderBottom: `${ClinTheme.borderWidths[0]}px solid ${ClinTheme.colors.grey}`
})

export const StyledDocumentCardInner = styled.div({
  display: 'flex',
  flex: '0 0'
})

export const StyledProductDetail = styled.div({
  paddingTop: ClinTheme.space[3],
  [`${StyledAccordion}`]: {
    [`${StyledDocumentCard}:last-of-type`]: {
      borderBottom: 'none',
      paddingBottom: ClinTheme.space[5]
    }
  }
})

export const StyleDocumentationDetail = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between'
})

export const StyleDocumentationDetailButton = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
  marginTop: ClinTheme.space[4],

  [mediaQuery(MediumUpBreakpoint)]: {
    marginTop: 0
  }
})

export const StyledNoProductDocuments = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  paddingBottom: ClinTheme.space[4],

  [mediaQuery(MediumUpBreakpoint)]: {
    paddingBottom: ClinTheme.space[6]
  },

  [`${StyledClinText}`]: {
    fontSize: ClinTheme.fontSizes[3],
    fontWeight: ClinTheme.fontWeights.bold,

    [mediaQuery(MediumUpBreakpoint)]: {
      fontSize: ClinTheme.fontSizes[4]
    }
  }
})

export const StyledDocumentsLinkContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  [`.clin-text-document-link`]: {
    display: 'inline-block'
  }
})

export const StyledEstimatedTimeRow = styled.div({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  padding: `${ClinTheme.space[3]}px 0`
})

export interface IClinStyleEddAusProps {
  padding?: string
}

export const StyledEstimatedTimeRowAus = styled.div<IClinStyleEddAusProps>(
  {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between'
  },
  ({ padding }) => ({
    padding: padding ? padding : `${ClinTheme.space[0]}px 0`
  })
)

export const StyledHeaderTitleContainer = styled.div({
  display: 'flex',
  alignItems: 'center'
})

export const StyledHeaderTitleMobileContainer = styled.div({
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
})

export const StyledHeaderTitle = styled(ClinText)<IClinTextProps>({
  fontFamily: ClinTheme.fonts.groteskBold,
  fontSize: ClinTheme.fontSizes[5],
  fontWeight: ClinTheme.fontWeights.bolder,
  lineHeight: ClinTheme.lineHeights.heading[4]
})

export const StyledDeliveryCard = styled.div({
  minHeight: '88px',
  minWidth: '220px',
  display: 'flex',
  alignItems: 'center',
  gap: ClinTheme.space[3],
  backgroundColor: ClinTheme.colors.deliveryDateBackground,
  borderRadius: ClinTheme.space[2],
  padding: `0px ${ClinTheme.space[4]}px`,
  fontFamily: ClinTheme.fonts.groteskBold
})

export const StyledProductInformation = styled('div')({
  backgroundColor: ClinTheme.colors.tooltipText,
  padding: ClinTheme.space[4],
  paddingBottom: 0,
  borderRadius: ClinTheme.space[2]
})

export const StyledRow = styled('div')({
  display: 'flex',
  gap: ClinTheme.space[4],
  flexWrap: 'wrap'
})

export const StyledRowMobile = styled(Row)`
  margin-right: 0;

  @media (max-width: ${MediumUpBreakpoint}px) {
    .quote-block {
      order: 1 !important;
      maxwidth: 100%;
    }
    .info-block {
      order: 2 !important;
    }
  }
`

export const StyledInformationRowMobile = styled('div')({
  display: 'flex',
  alignItems: 'stretch',
  marginBottom: ClinTheme.space[4],
  flexWrap: 'wrap',

  '&:last-child': {
    marginBottom: 0
  },

  [mediaQuery(MediumUpBreakpoint)]: {
    flexDirection: 'column'
  }
})

export const ColumnMobile = styled('div')({
  flex: 1,
  [mediaQueryDown(MediumUpBreakpoint)]: {
    minWidth: '100%',
    marginBottom: ClinTheme.space[2]
  }
})

export const StyledInformationRow = styled('div')({
  display: 'flex',
  alignItems: 'stretch',
  marginBottom: ClinTheme.space[4],

  '&:last-child': {
    marginBottom: 0
  }
})

export const Column = styled.div<IColumnProps>({
  flex: 1,
  display: 'flex',
  flexDirection: 'column'
})

export const StyledLicenseBox = styled.div({
  height: '26px',
  width: '100%',
  marginTop: ClinTheme.space[1]
})

export const HeaderText = styled('div')({
  marginBottom: ClinTheme.space[2],
  fontFamily: ClinTheme.fonts.heading,
  color: ClinTheme.colors.darkGrey,
  fontWeight: ClinTheme.fontWeights.medium,
  fontSize: ClinTheme.fontSizes[0],
  lineHeight: ClinTheme.lineHeights.largeParagraph
})

export const InformationText = styled('div')({
  fontFamily: ClinTheme.fonts.body,
  color: ClinTheme.colors.black,
  fontSize: ClinTheme.fontSizes[1],
  fontWeight: ClinTheme.fontWeights.medium,
  lineHeight: ClinTheme.lineHeights.largeParagraph
})

export const StyledStrengthText = styled.span({
  fontSize: ClinTheme.fontSizes[5],
  lineHeight: ClinTheme.lineHeights.heading[3],
  whiteSpace: 'pre-wrap',
  fontFamily: ClinTheme.fonts.groteskRegular,
  fontWeight: ClinTheme.fontWeights.normal
})

export const StyledReturnButton = styled.div({
  height: ClinTheme.space[4],
  marginTop: ClinTheme.space[3]
})

export const StyledEstimatedTimeToolTip = styled.span({
  display: 'inline-flex',
  position: 'relative',
  height: ClinTheme.space[3],
  width: ClinTheme.space[3]
})

export const StyledBookmarkButton = styled.div({
  marginLeft: 'auto'
})

export const StyledEstimatedTimeToolTipWrap = styled.span({
  display: 'inline-flex',
  position: 'relative',
  height: ClinTheme.space[3],
  width: ClinTheme.space[3],

  [betweenQueryTooltip(ClinTheme.breakpoints[1], ClinTheme.breakpoints[2])]: {
    left: '-100px !important'
  }
})
export const StyledClinTable = styled(ClinTable)<{ width?: string }>`
  width: 100%;
  max-width: 100%;
  table-layout: fixed;
  overflow: visible;
`

export const StyledStrengthCell = styled('div')({
  marginTop: '6px',

  '&:first-child': {
    marginTop: 0
  }
})

export const StyledClinPatientTableHeaderCell = styled(
  ClinPatientTableHeaderCell
)({
  cursor: 'default',
  padding: '24px 16px',

  div: {
    display: 'block'
  }
})
export const FixedWidthCell = styled.div<{
  width?: string
  minWidth?: string
  maxWidth?: string
}>`
  width: ${(props) => props.width};
  min-width: ${(props) => props.minWidth};
  max-width: ${(props) => props.maxWidth};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const QuoteBlock = styled(Col)`
  padding: 0;
  order: 2;
  max-width: 268px;

  @media (max-width: ${MediumUpBreakpoint}px) {
    max-width: 100%;
    width: 100%;
    order: 1 !important;
    padding-left: ${ClinTheme.space[3]}px;
    padding-right: ${ClinTheme.space[3]}px;
  }
`

export const StyledClinTableRowMobile = styled(
  ClinTableRow
)<ClinTableRowStyledProps>({
  border: 0,
  background: `${ClinTheme.colors.white}`,
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '10px',
  [mediaQueryDown(MediumUpBreakpoint)]: {
    flexDirection: 'column'
  },
  [mediaQueryDown(360)]: {
    display: 'flex'
  }
})

export const StyledClinTableBodyCellMobile = styled(ClinTableBodyCell)({
  padding: '0px 0px 0px 16px',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontSize: '12px',
  fontWeight: ClinTheme.fontWeights.medium,
  [mediaQueryDown(MediumUpBreakpoint)]: {
    flexDirection: 'column',
    alignItems: 'flex-start'
  }
})

export const InformationRow = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: ClinTheme.space[3]
})

export const StyledClinTableBodyCell = styled(ClinTableBodyCell)({
  padding: '16px',

  '&:first-child': {
    paddingLeft: '16px'
  },

  '&:last-child': {
    paddingRight: '20px',
    textAlign: 'right',

    'button.icon-toggle': {
      margin: '4px',
      color: ClinTheme.colors.primaryMid
    }
  },

  '&:nth-last-child(2)': {
    div: {
      overflow: 'visible'
    }
  }
})
export const StyledClinTableRow = styled(ClinTableRow)<ClinTableRowStyledProps>`
  border: 0;
  margin-bottom: 10px;
  cursor: default;
  background: ${ClinTheme.colors.white};
  &:focus {
    background: ${ClinTheme.colors.white};
  }
`
export const StyledDocumentsTableContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  marginTop: ClinTheme.space[4]
})
export const StyledDocumentsTableTitle = styled(ClinText)({
  padding: ClinTheme.space[3],
  backgroundColor: ClinTheme.colors.white,
  borderBottom: `${ClinTheme.borderWidths[0]}px solid ${ClinTheme.colors.grey}`
})
export const StyledDocumentActions = styled.p({
  padding: 0,
  display: 'flex',
  justifyContent: 'flex-end'
})

export const StyledButtonLabel = styled.div({
  display: 'inline-block',
  margin: '0 5px'
})

export const StyledDetailsContact = styled.div({
  cursor: 'pointer'
})
